import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.directive('ngEnter', function () {
    return function (scope, element, attrs) {
        const handler = function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter, {$event: event});
                });
                event.preventDefault();
            }
        };

        element.bind("keydown keypress", handler);

        scope.$on('$destroy', function () {
            element.unbind("keydown keypress", handler);
        });
    };
});